require('bootstrap-treeview/dist/bootstrap-treeview.min');

var Marionette = require('backbone.marionette');
var OrganizationForm = require('./organization-form');
var OrganizationsCollections = require('../../collections/organizations-collection');
var Organization = require('../../models/organization');

var CommonUtils = require('../../utils/common-utils.js');

var Organizations = Marionette.View.extend({
    template: require('../../templates/organizations/organizations.html'),
    //collection: new OrganizationsCollections(),
    model: new Organization(),

    events: {
        'click #save-organization': 'saveOrganization',
        'keyup input#filter': 'applyFilter'
    },

    regions: {
        modal: '#addOrganizationModal',
        form: '#form',
        tree: '#tree'
    },

    ui: {
        modal: '#addOrganizationModal',
        saveBtn: '#save-organization'
    },

    collectionEvents: {
        add: 'itemAdded',
        request: 'showLoading',
        sync: 'hideLoading',
        error: 'logError'
    },

    childViewEvents: {
        'organization:save:valid': 'saveOrganizationBtnEnableOrDisable'
    },


    templateContext: function () {
        return {
            byAdmin: this.options.byAdmin
        }
    },

    initialize: function (options) {
        _.bindAll(this, 'onRender', 'renderTree', 'collectionToTree', 'itemSaved',
            'saveOrganization', 'applyFilter', 'satisfiesFilter', 'stringContains',
            'saveOrganizationBtnEnableOrDisable'); // fixes loss of context for 'this' within methods

        this.utils = new CommonUtils();
        this.params = $.deparam(window.location.hash.replace('#organizations', '').replace('?', ''));
        this.collection = new OrganizationsCollections([],
            {params: this.utils.queryParamsToCollection(this.params) || []});
    },

    onRender: function () {
        window.document.title = "RNS Organizations";
        this.organizationForm = new OrganizationForm({
            model: this.model,
            isEditMode: false
        });
        this.showChildView('form', this.organizationForm);
        this.collection.fetch({success: this.renderTree});
    },

    renderTree: function (response, array, collection, filter) {
        $('#tree').treeview({
            data: this.collectionToTree(this.collection.toJSON(), filter),
            enableLinks: true,
            showTags: true
        });
    },

    saveOrganization: function () {
        this.ui.modal.modal('hide');
        this.model = this.organizationForm.fillModel();
        this.model.save(this.model.toJSON(), {success: this.itemSaved});
    },

    itemAdded: function () {
        this.model = this.organizationForm.clearModel();
    },

    itemSaved: function () {
        this.collection.add(this.model.clone());
        this.renderTree();
    },

    collectionToTree: function (collection, filter) {
        var that = this;
        var tree = [];
        if ((collection || []).length == 0) {
            return undefined;
        }
        collection.filter(function (organization) {
            return that.satisfiesFilter(organization, filter)
        }).forEach(function (organization) {
            var tags = [];
            if (organization.relatedAs) {
                tags.push(organization.relatedAs);
            }
            tree.push({
                icon: 'glyphicon glyphicon-home',
                text: organization.name,
                href: '/#organization/' + organization.id,
                tags: tags,
                state: {
                    expanded: false
                },
                nodes: that.collectionToTree((organization.relations || []).map(function (relation) {
                    relation.child.relatedAs = (relation.type ? relation.type.name : undefined);
                    return relation.child
                }))
            });
        });
        return _.sortBy(tree, function (o) {
            return o.text;
        });
    },

    applyFilter: function (event) {
        this.renderTree({}, {}, {}, event.target.value);
    },

    satisfiesFilter: function (organization, filter) {
        return !filter || filter == '' ||
            this.stringContains(organization.name, filter) ||
            this.stringContains(organization.npi, filter);
    },

    stringContains: function (str, substr) {
        str = (str || '').toLowerCase();
        substr = (substr || '').toLowerCase();
        return str.indexOf(substr) !== -1
    },

    showLoading: function () {
        this.$('.loading').show();
    },

    hideLoading: function () {
        this.$('.loading').hide();
    },

    logError: function (obj, response) {
        this.$('.loading').hide();
        this.triggerMethod('server:error', response.responseText);
    },

    saveOrganizationBtnEnableOrDisable: function (data) {
        if (data.result)
            this.ui.saveBtn.removeAttr("disabled");
        else
            this.ui.saveBtn.attr("disabled", "true");
    }

});

module.exports = Organizations;


//////////////////
// WEBPACK FOOTER
// ./app/views/organizations/organizations.js
// module id = 214
// module chunks = 0